import { ChangeEvent } from "react";

import DocScoutUploadIcon from "@assets/icons/doc-scout-upload.svg";

import { DEAL_DOC_ACCEPT_ATTRIBUTE } from "@config/constants";

interface IUploaderInputProps {
  onFilesSelected: (files: File[]) => void;
}

export function UploaderInput({ onFilesSelected }: IUploaderInputProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      onFilesSelected(Array.from(e.target.files));
    }
  };

  return (
    <div className="sticky py-2.5 px-1 flex flex-col gap-2 bg-white/70 dark:bg-gray-800/70 rounded-md">
      <label htmlFor="file-upload">
        <div className="flex items-center gap-2 cursor-pointer">
          <div className="w-10 h-10 flex justify-center items-center">
            <DocScoutUploadIcon
              width={24}
              height={24}
              className=" text-teal-600 dark:text-teal-200"
            />
          </div>

          <div className="flex flex-col">
            <h4 className="font-[500] text-sm text-content-primary dark:text-invertedPrimary">
              Create deal details faster
            </h4>
            <span className="max-w-44 font-[500] text-xs text-content-secondary dark:text-invertedPrimary80">
              <u className="text-teal-600 dark:text-teal-200 mr-1 cursor-pointer">Upload CIM</u>
              <span>file to extract key metrics with Scout</span>
            </span>
          </div>
        </div>
      </label>

      <input
        id="file-upload"
        className="hidden"
        type="file"
        accept={DEAL_DOC_ACCEPT_ATTRIBUTE}
        onChange={handleChange}
        multiple
      />
    </div>
  );
}
